<template>
    <div class="card">
        <div class="card__header">
			<h5 class="card__title">История выплат</h5>
        </div>
		<div class="card__body">
			<div class="table-wrap">
				<table class="table">
					<thead>
						<tr>
							<th>Игрок</th>
							<th>Метод</th>
							<th>Реквизиты</th>
							<th>Сумма</th>
							<th>Время</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="wdw in wdws">
							<td>{{ wdw.username }}</td>
							<td>{{ wdw.system }}</td>
							<td>{{ wdw.wallet }}</td>
							<td>{{ parseFloat(wdw.amount).toFixed(2) }}</td>
							<td class="nowrap">{{ wdw.date }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                wdws: [],
                tableLength: 20,
            }
        },
        methods: {
            fillTable() {
                this.$root.axios.get('/api/withdraw/latest')
                    .then(res => {
                        this.wdws = res.data;
                    });
            },
        },
        beforeMount() {
            this.fillTable()
        }
    }
</script>
